"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.avatar.list': 'Avatary',
    'route.avatar.create': 'Dodaj avatar',
    'route.avatar.edit': 'Edytuj avatar',
    'route.avatar.preview': 'Podgląd awatara',
};
